import React from 'react'

export default function NotFound({ onRetour }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f0fdf8 0%, #e8f7f2 100%)',
      padding: '0 20px',
      textAlign: 'center',
    }}>
      {/* Logo */}
      <div style={{
        width: 64,
        height: 64,
        background: '#1D9E75',
        borderRadius: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: 30,
        fontWeight: 700,
        boxShadow: '0 8px 24px rgba(29,158,117,0.3)',
        marginBottom: 32,
      }}>
        C
      </div>

      {/* Code 404 */}
      <div style={{
        fontSize: 96,
        fontWeight: 800,
        color: '#1D9E75',
        lineHeight: 1,
        marginBottom: 8,
        letterSpacing: '-4px',
      }}>
        404
      </div>

      <h1 style={{
        fontSize: 24,
        fontWeight: 700,
        color: '#1a202c',
        margin: '0 0 12px 0',
      }}>
        Page introuvable
      </h1>

      <p style={{
        fontSize: 15,
        color: '#718096',
        maxWidth: 360,
        lineHeight: 1.6,
        margin: '0 0 32px 0',
      }}>
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>

      <button
        onClick={onRetour || (() => window.location.href = '/')}
        style={{
          background: '#1D9E75',
          color: 'white',
          border: 'none',
          borderRadius: 10,
          padding: '12px 28px',
          fontSize: 15,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 14px rgba(29,158,117,0.35)',
          transition: 'opacity 0.2s',
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
      >
        ← Retour à l'accueil
      </button>
    </div>
  )
}
